import React from 'react';
import { IconButton } from '@mui/material';
import ArrowUpCollapseIcon from '@/assets/icons/arrow-up-collapse-icon.svg?react';
import ArrowDownCollapseIcon from '@/assets/icons/arrow-down-collapse-icon.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';

const CustomCollapseButton = ({ isOpen, onToggle }) => {
    return (
        <IconButton className='collapse-button' sx={{ backgroundColor: isOpen ? Palette.gray.gray200 : Palette.gray.gray150 }} onClick={onToggle} type='button'>
            {isOpen ? <ArrowDownCollapseIcon /> : <ArrowUpCollapseIcon />}
        </IconButton>
    );
};

export default CustomCollapseButton;
